<template>
	<div>
		<!-- 加载状态 -->
		<div id="loading" v-if="isLoading && !error">
			<div class="spinner"></div>
			<p>正在加载聊天组件...</p>
		</div>

		<!-- 错误状态 -->
		<div id="error" v-if="error">
			<p id="error-msg">{{ error.message }}</p>
			<button @click="initializeChat">重试</button>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'CozeChat',
		data() {
			return {
				isLoading: true,
				error: null,
				observer: null,
				chatClient: null,
				// 配置项
				config: {
					token: 'sat_yQJICzaW7wljzmuSfPgfmfdDPDDUkRRgzhA3gQIRGI1RaoW7t6htHD9pk9vLDGrJ',
					sdkUrl: 'https://lf-cdn.coze.cn/obj/unpkg/flow-platform/chat-app-sdk/1.1.0-beta.3/libs/cn/index.js'
				}
			};
		},
		props: {
			// 外部传入智能体ID（也可以写死在组件内）
			agentId: {
				type: String,
				required: true
			},
			cozeWidth: {
				type: Number,
				required: true
			},
			title: {
				type: String,
				required: true
			},
		},
		mounted() {
			this.initializeChat();
		},
		beforeDestroy() {
			if (this.observer) {
				this.observer.disconnect();
			}
		},
		methods: {
			// 动态加载 SDK 脚本
			loadScript(url) {
				return new Promise((resolve, reject) => {
					if (window.CozeWebSDK) {
						return resolve(window.CozeWebSDK);
					}

					const script = document.createElement('script');
					script.src = url;
					script.onload = () => resolve(window.CozeWebSDK);
					script.onerror = (err) => reject(new Error(`加载 SDK 失败: ${err.message}`));
					document.body.appendChild(script);
				});
			},

			// 初始化聊天
			async initializeChat() {
				try {
					this.isLoading = true;
					this.error = null;

					// 1. 加载 SDK
					const CozeWebSDK = await this.loadScript(this.config.sdkUrl);

					// 2. 创建聊天客户端
					this.chatClient = new CozeWebSDK.WebChatClient({
						config: {
							bot_id: this.agentId
						},
						componentProps: {
							title: this.title
						},
						auth: {
							type: 'token',
							token: this.config.token,
							onRefreshToken: () => this.config.token
						}
					});

					// 3. 显示聊天窗口
					if (this.chatClient && typeof this.chatClient.showChatBot === 'function') {
						this.chatClient.showChatBot();
						console.log('✅ 聊天窗口已显示');
					} else {
						throw new Error('ChatClient 初始化失败或 showChatBot 方法不存在');
					}

					// 4. 确保样式和 DOM 观察器生效
					setTimeout(() => {
						this.forceFullscreen();
						this.startObservingDOM();
					}, 300);

				} catch (err) {
					this.error = err;
					console.error('❌ 初始化聊天失败:', err);
				} finally {
					this.isLoading = false;
				}
			},

			// 强制应用全屏样式
			forceFullscreen() {
				const chatBot = document.querySelector('.fa8097ff55eabaa5782b');
				console.log(this.cozeWidth)
				const topNum=this.cozeWidth<768?100:120;
				const heightNum=this.cozeWidth<768?76:80;
				if (chatBot) {
					chatBot.style.cssText = `
						top: ${topNum}px !important;
						left: 0 !important;
						right: 0 !important;
						bottom: 0 !important;
						width: ${this.cozeWidth}px !important;
						height: ${heightNum}vh !important;
						max-width: ${this.cozeWidth}px !important;
						max-height: ${heightNum}vh !important;
						margin: 0 auto !important;
						padding: 0 !important;
						border: none !important;
						border-radius: 0 !important;
						box-shadow: none !important;
						transform: none !important;
						z-index: 9 !important;
					`;
					console.log('✅ 全屏样式已强制应用');
				}
			},

			// 监听 DOM 变化以确保样式持续生效
			startObservingDOM() {
				const chatBot = document.querySelector('.fa8097ff55eabaa5782b');
				if (!chatBot || this.observer) return;

				this.observer = new MutationObserver((mutations) => {
					mutations.forEach((mutation) => {
						if (mutation.addedNodes.length) {
							this.forceFullscreen();
						}
					});
				});

				this.observer.observe(chatBot, {
					childList: true,
					subtree: true
				});
			}
		}
	};
</script>

<style scoped>
	/* 组件内部样式 */
	#loading,
	#error {
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		text-align: center;
		z-index: 999999;
		/* 确保在最上层 */
		background: white;
		padding: 20px 30px;
		border-radius: 8px;
		box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
	}

	.spinner {
		width: 50px;
		height: 50px;
		border: 4px solid #f3f3f3;
		border-top: 4px solid #3b82f6;
		border-radius: 50%;
		animation: spin 1s linear infinite;
		margin: 0 auto 16px;
	}

	@keyframes spin {
		0% {
			transform: rotate(0deg);
		}

		100% {
			transform: rotate(360deg);
		}
	}

	#error p {
		color: #f56c6c;
		margin-bottom: 16px;
		font-size: 16px;
	}

	#error button {
		padding: 8px 16px;
		background-color: #3b82f6;
		color: white;
		border: none;
		border-radius: 4px;
		cursor: pointer;
		transition: background-color 0.2s;
	}

	#error button:hover {
		background-color: #2563eb;
	}

	.coze-chat-sdk {
		display: none !important;
	}
</style>
<style>
	.e4f8c2c1d9d493c0cfdb {
		display: none !important;
	}
</style>